// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","text":"Header_text__G3J9D constants_fonts__FFeIK constants_colors__2ZDH7"};